/**
 * this helper logic of formating upcoming event such normal view, or calendar
 * this also formating upcoming event that show in home page
 */

import * as moment from 'moment';
import { Injectable } from '@angular/core';

enum Icons {
  Car = 'car-side',
  Helicopter= 'helicopter',
  Bus = 'bus',
  Plane = 'plane'
}

@Injectable({
  providedIn: 'root',
})
export class UpcomingUtils {
  /**
   * construct upcoming event
   * @param upcoming list upcoming items
   * @returns array of upcoming event if not from home page then it will always return single upcoming
   */
  upcomingEvent(upcoming, fromHome=false) {
    const today = moment().startOf('day')
    let index = upcoming.findIndex(val => {
      return moment(val.date, 'DD/MM/YYYY').isSameOrAfter(today);
    });

    const upcomingPair = [];
    if (index !== -1) {
      if (fromHome) {
        let foundFromWork = false;
        while(index >= 0) {
          // Check if current index of upcoming is start of swing
          if ((upcoming[index-1]?.name === 'From Work' || index === 0) && (moment(upcoming[index]?.date, 'DD/MM/YYYY').isAfter(today) || foundFromWork)) {
            upcomingPair.unshift(this.mapUpcomingEvent(upcoming, index));
            index = -1;
          } else {
            // otherwise find from work index and use it to find all booking in the swing
            if (!foundFromWork) {
              index = upcoming.findIndex(val => moment(val.date, 'DD/MM/YYYY').isSameOrAfter(today) && val.name === 'From Work');
              foundFromWork = true;
            }
            upcomingPair.unshift(this.mapUpcomingEvent(upcoming, index));
          }
          index -= 1
        }
      } else {
        upcomingPair.push(this.mapUpcomingEvent(upcoming, index))
      }
    }
    return upcomingPair;
  }

  getAccommodationDaysAway(accom) {
    return moment(accom.checkIn, 'DD-MM-YYYY').startOf('day').diff(moment().startOf('day'), 'days');
  }

  mapUpcomingEvent(upcomings, index) {
    let upcomingEvent = upcomings[index];
    if (upcomingEvent.transportDetails.sectorDetails) {
      upcomingEvent.transportDetails.sectorDetails = upcomingEvent.transportDetails.sectorDetails.map(sector => {
        if (upcomingEvent.name === 'To Work') {
          if (upcomingEvent.accommodation.length > 0) {
            sector.direction = `to ${sector.arriveLocation}`;
          }
        } else {
          const prevToWorkEvent = upcomings[index -1];
          if (prevToWorkEvent) {
            if (prevToWorkEvent.accommodation.length > 0) {
              sector.direction = `from ${sector.departLocation}`;
            }
          }
        }
        return sector;
      });
    }
    if (upcomingEvent.transportDetails.flightNumber === 'DRV') {
      try {
        upcomingEvent.direction = upcomings[index].name === 'To Work' ?
        `to ${upcomings[index].accommodation[0].camp}` : `from ${upcomings[index - 1].accommodation[0].camp}`;
      } catch (error) {
        upcomingEvent.direction = '';
      }
      upcomingEvent.transportDetails.bookingstatus = upcomingEvent.transportDetails.bookingstatus ?
      upcomingEvent.transportDetails.bookingstatus : 'Confirmed';
    }
    upcomingEvent = this.bookingStatus(upcomingEvent);
    upcomingEvent.accommodation.map((accom) => {
      accom.daysAway = this.getAccommodationDaysAway(accom);
      return accom;
    });
    return upcomingEvent;
  }

  upcomingList(upcoming, type?) {
    // find item with waitlisted
    const waitlisted = upcoming.filter(val => {
      return (moment(val.date, 'DD-MM-YYYY') >= moment().startOf('day')) && val.transportDetails.bookingstatus === 'Waitlisted';
    });

    // get list of upcoming event
    const upcomingList = upcoming.filter(val => {
      if (val.accommodation.length > 0 && type === 'calendar') {
        return moment(val.accommodation[val.accommodation.length - 1].checkOut, 'DD-MM-YYYY') >= moment().startOf('day') ||
        !val.accommodation.checkOut;
      }
      if (type === 'notification') {
        return true;
      }
      return moment(val.date, 'DD-MM-YYYY') >= moment().startOf('day');
      }).map((val, index) => {
      const item = val;

      // if event is driving set direction
      if (item.transportDetails.mode === 'Car') {
        // if event is to work then set direction to last accommodation camp
        // if oneday trip has not direction
        try {
          item.direction = upcoming[index].name === 'To Work' ? upcoming[index].accommodation[0].camp : upcoming[index - 1].accommodation[0].camp;
        } catch (err) {
          item.direction = '';
        }
      }

      item.transportDetails.bookingstatus = item.transportDetails.bookingstatus ? item.transportDetails.bookingstatus : 'Confirmed';
      item.transportDetails.icon = Icons[item.transportDetails.mode];
      item.transportDetails.class = item.name === 'From Work' ? 'icon-flipped' : '';

      // Find if the current transport has waitlisted transports from the same site
      // Waitlisted transport must be in the next order (by Id) after the main transport upcomingId
      // and the upcomingId not after the next main transport upcomingId
      if (val.transportDetails.bookingstatus !== 'Waitlisted') {
        item.transportQueue = waitlisted.filter(waitlist => {
          return waitlist.site === val.site && waitlist.id === (val.id + 1);
        });
      }

      val.accommodation.map((accom) => {
        accom.daysAway = this.getAccommodationDaysAway(accom);
        return accom;
      });
      return this.bookingStatus(item);
      });
    return upcomingList;
  }

  bookingStatus(event) {
    event.show = event.transportDetails.bookingstatus !== 'Waitlisted' ? true : false;

    event.transportDetails.bookingStatusView = event.transportDetails.bookingstatus;
    event.transportDetails.bookingStatusMessage = `You are ${event.transportDetails.bookingstatus}` ;
    event.lastUpdateDisplay = moment(event.transportDetails.bookingstatuslastupdated).fromNow();

    return event;
  }
}
